import React from "react";
import { Container } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Experience from "./Experience";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container as="main" fluid className="about-section">
      <Container>
        <section className="experience-shell">
          <div className="section-header">
            <h1 className="section-heading">Work History</h1>
          </div>
          <Experience />
        </section>

        <section className="skills-shell">
          <div className="section-header">
            <h2 className="section-heading">Languages, Frameworks, and Platforms</h2>
          </div>
          <Techstack />
        </section>

        <section className="skills-shell">
          <div className="section-header">
            <h2 className="section-heading">Development Tools</h2>
          </div>
          <Toolstack />
        </section>

        <Github />
      </Container>
    </Container>
  );
}

export default About;
